import React, { useState } from "react";
import { jsPDF } from "jspdf";
import whiteLogo from "../images/WhiteQFPLogo.png";
import coverBG from "../images/PDFImages/Cover Sheet - White label.png";
import html2canvas from "html2canvas";
import Popup from "reactjs-popup";

import ShieldIcon from "../images/PDFImages/Cover sheet icon 03.png";
import ClockIcon from "../images/PDFImages/Cover sheet icon 02.png";
import FlagIcon from "../images/PDFImages/Cover Sheet Icon 01.png";
import Sealbgcover from "../images/PDFImages/Overall Score - PDF Circle BG.png";

import BronzeSeal from "../images/PDFImages/Total Score - Bronze.png";
import SilverSeal from "../images/PDFImages/Total Score - Silver.png";
import GoldenSeal from "../images/PDFImages/Total Score - Gold.png";
import PlatinumSeal from "../images/PDFImages/Total Score - Platinum.png";

import TOC from "../images/PDFImages/Page 2.png";
import Intro from "../images/PDFImages/page 3.png";
import Works1 from "../images/PDFImages/page 4.png";
import Works2 from "../images/PDFImages/page 5.png";
import Anatomy from "../images/PDFImages/page 6.png";

import Defense_Post from "../images/PDFImages/Defense_Post.png";
import Defense_Post_2 from "../images/PDFImages/Defense_Post_2.png";
import Offense_Post from "../images/PDFImages/Offense_Post.png";
import Efficiency_Post from "../images/PDFImages/Efficiency_Post.png";
import LastPage from "../images/PDFImages/Last.png";

import ConvertTimeStamp from "../Utils/ConvertTimeStamp";
import SortSmartContracts from "../Utils/SortSmartContracts";

import MQLogo from "../images/Logos/Model Q/Q-Financial-Logo.png";
import QFPLogo from "../images/Logos/Original/WhiteQFPLogo.png";

function CreatePDF(props) {
  const [open, setOpen] = useState(false);
  const QuoteData = props.Quotes;
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  let pdfLogo = props.logo === undefined ? whiteLogo : props.logo;
  console.log("pdfLogo :>> ", pdfLogo);
  // let pdfLogo = whiteLogo;
  // if(props.logo.includes("Q-Financial"))
  //   pdfLogo = MQLogo;
  const pdfName = props.pdfName.toString().replaceAll(" ", "_");
  const pdfDate = props.pdfDate.toString();
  const dFileName = `${pdfName}-${ConvertTimeStamp(pdfDate).replaceAll(
    "/",
    " "
  )}`;
  // console.log("PDF Name", pdfName);
  // console.log("PDF Date", pdfDate);
  const FD = ConvertTimeStamp(props.pdfDate, true);

  // console.log("Formatted Date", FD);
  // console.log("GetDate()", FD.getDate());

  const LongDate = `${
    months[FD.getMonth()]
  } ${FD.getDate()}, ${FD.getFullYear()} `;
  // console.log("LongDate", LongDate);
  function closeModal() {
    setOpen(false);
  }

  async function openModal() {
    setOpen(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
  }
  function clickHandler() {
    openModal().then(() => createPDF());
  }

  const createPDF = async () => {
    const pdf = new jsPDF(" p", "mm", "a4", true);
    // pdf.setTextColor(7, 17, 90);
    // pdf.setFontSize(12).setFont(undefined, "normal");
    // pdf.text("Top: 0,10", 0, 10);
    // pdf.text("Mid: 10,150", 10, 150);
    // pdf.text("Bot: 0,290", 0, 290);

    // pdf.addPage();
    async function addSectionToPDF(
      secionClass,
      x,
      y,
      pdf,
      padding,
      w = 1,
      h = 1
    ) {
      if (padding === undefined) padding = 10;
      let sectionElement = document.querySelector(`#${secionClass}`);
      let canvas = await html2canvas(sectionElement);
      let sectionItem = canvas.toDataURL("image/png");

      let imgProperties = pdf.getImageProperties(sectionItem);
      let pdfWidth = pdf.internal.pageSize.getWidth() - padding * 2;
      let pdfHeight =
        ((imgProperties.height - padding * 2) * pdfWidth) / imgProperties.width;
      if (w === 1 || h === 1) {
        pdf.addImage(sectionItem, "PNG", x + padding, y, pdfWidth, pdfHeight);
      } else {
        pdf.addImage(sectionItem, "PNG", x + padding, y, w, h);
      }
    }

    // function printSmartContractsOld(arr, index, yOffset = 0) {
    //   if (arr[index] !== undefined) {
    //     if (index === 5) {
    //       pdf.addPage();
    //       yOffset = -1 * 120 + 35 * index;
    //     }
    //     let icon = arr[index].Icon;
    //     let summary = arr[index].Summary;
    //     let desc = arr[index].Description;
    //     let txt = pdf.splitTextToSize("\t" + summary, 40);
    //     pdf.text(10, 125 + 35 * index, txt);
    //     txt = pdf.splitTextToSize("\t" + desc, 110);
    //     pdf.text(90, 125 + 35 * index, txt);
    //     pdf.addImage(
    //       require(`../images/SMARTContractIcons/${icon}`),
    //       "PNG",
    //       55,
    //       yOffset + 120 + 35 * index,
    //       30,
    //       30
    //     );
    //   }
    // }

    function prActionStep(arr, index, y, calcOnly = false) {
      if (arr[index] !== undefined) {
        pdf.setFontSize(14).setFont(undefined, "bold");
        let summary = arr[index].Summary;
        let sumtxt = pdf.splitTextToSize(summary, 185);
        let summaryOffset = 5 * sumtxt.length + 5;

        pdf.setFontSize(12).setFont(undefined, "normal");
        let desc = arr[index].Description;
        let desctxt = pdf.splitTextToSize(desc, 180);
        let descOffset = 5 * desctxt.length + 5;

        // console.log("index:", index);
        // console.log("text:", sumtxt);
        // console.log("lines:", sumtxt.length);

        if (calcOnly) {
          return descOffset + summaryOffset;
        }
        //Summary

        pdf.setFontSize(14).setFont(undefined, "bold");
        pdf.text(15, y, sumtxt);
        //Desctiption
        pdf.setFontSize(12).setFont(undefined, "normal");

        pdf.text(15, y + summaryOffset, desctxt);
        return descOffset + summaryOffset;
      }
    }

    // #region Cover Page
    // Background
    pdf.addImage(
      coverBG,
      "PNG",
      0,
      0,
      pdf.internal.pageSize.getWidth(),
      pdf.internal.pageSize.getHeight()
    );
    // Logo

    pdf.addImage(pdfLogo, "PNG", 10, 10, 40, 40);
    //Choose Seal
    let Seal;
    switch (props.Info.Scores.Stars.Total.Rank) {
      case "Bronze":
        Seal = BronzeSeal;
        break;
      case "Silver":
        Seal = SilverSeal;
        break;
      case "Gold":
        Seal = GoldenSeal;
        break;
      case "Platinum":
        Seal = PlatinumSeal;
        break;
      default:
        Seal = BronzeSeal;
        break;
    }
    pdf.addImage(Sealbgcover, "PNG", 80, 160, 130, 130);
    pdf.addImage(Seal, "PNG", 80, 160, 130, 130);

    //small scores
    let iconsize = 25;
    pdf.addImage(ShieldIcon, "PNG", 10, 205, iconsize, iconsize);
    pdf.addImage(FlagIcon, "PNG", 10, 205 + (3 + iconsize), iconsize, iconsize);
    pdf.addImage(
      ClockIcon,
      "PNG",
      10,
      205 + (3 + iconsize) * 2,
      iconsize,
      iconsize
    );

    pdf.setTextColor(7, 17, 90);
    pdf.setFontSize(22);
    pdf.text(`${LongDate.toUpperCase()}`, 130, 47);

    pdf.setFontSize(8);
    pdf.text(`Defense Score`, 24, 230, { align: "center" });
    pdf.text(`Offense Score`, 24, 261, { align: "center" });
    pdf.text(`Efficiency Score`, 24, 288, { align: "center" });

    pdf.setFontSize(9).setFont(undefined, "bold");
    pdf.text(`${props.Info.Scores.Defense.TotalScore}`, 23, 219, {
      align: "center",
    });
    pdf.text(`${props.Info.Scores.Offense.TotalScore}`, 23, 245, {
      align: "center",
    });
    pdf.text(`${props.Info.Scores.Efficiency}`, 23, 275, {
      align: "center",
    });
    // Name
    pdf.setTextColor(255, 255, 255);
    pdf.setFontSize(18);
    pdf.text(`Prepared for ${props.pdfName}`, 20, 160);

    pdf.setFontSize(100);
    pdf.text(`${props.Info.Scores.Total}`, 145, 235, { align: "center" });

    //#endregion Cover Page

    //#region Quote
    function getRandomInt(max) {
      return Math.floor(Math.random() * max);
    }
    const randomQuote = QuoteData[getRandomInt(QuoteData.length)];
    const QuoteText1 = `“${randomQuote.quote}”`;
    const QuoteText2 = `-${randomQuote.author}`;
    pdf.addPage();
    pdf.setTextColor(7, 17, 90);
    pdf.setFontSize(18).setFont(undefined, "normal");
    const QText = pdf.splitTextToSize(QuoteText1, 180);
    const QAuth = pdf.splitTextToSize(QuoteText2, 140);

    const height = pdf.internal.pageSize.getHeight();
    const width = pdf.internal.pageSize.getWidth();
    pdf.text(QText, width / 2, height / 2 - 5 * QText.length, {
      align: "center",
    });
    pdf.setFontSize(18).setFont(undefined, "italic");
    pdf.text(QAuth, width / 2, height / 2 + 15, { align: "left" });
    //#endregion Quote

    //#region TOC Page
    pdf.addPage();
    pdf.addImage(
      TOC,
      "PNG",
      0,
      0,
      pdf.internal.pageSize.getWidth(),
      pdf.internal.pageSize.getHeight()
    );
    //#endregion TOC Page
    //#region Intro Page
    pdf.addPage();
    pdf.addImage(
      Intro,
      "PNG",
      0,
      0,
      pdf.internal.pageSize.getWidth(),
      pdf.internal.pageSize.getHeight()
    );
    //#endregion Intro Page
    //#region Works Pages
    pdf.addPage();
    pdf.addImage(
      Works1,
      "PNG",
      0,
      0,
      pdf.internal.pageSize.getWidth(),
      pdf.internal.pageSize.getHeight()
    );
    pdf.addPage();
    pdf.addImage(
      Works2,
      "PNG",
      0,
      0,
      pdf.internal.pageSize.getWidth(),
      pdf.internal.pageSize.getHeight()
    );
    //#endregion Works Pages
    //#region Anatomy Page
    pdf.addPage();
    pdf.addImage(
      Anatomy,
      "PNG",
      0,
      0,
      pdf.internal.pageSize.getWidth(),
      pdf.internal.pageSize.getHeight()
    );
    //#endregion Anatomy Page
    //#region Total Page
    //#endregion TotalPage

    pdf.setTextColor(7, 17, 90);

    async function sectionPage(pageName, pageHeader, SCArr) {
      let spacing = 10;
      // console.log("SCArr :>> ", SCArr);
      // console.log("SCArr.length :>> ", SCArr.length);
      let filteredSCArr = SortSmartContracts(SCArr, pageName);
      pdf.addPage();
      //Title
      pdf.setFontSize(40).setFont(undefined, "normal");
      pdf.text(
        pdf.internal.pageSize.getWidth() / 2,
        20,
        `Your total ${pageHeader}:`,
        {
          align: "center",
        }
      );
      //Initial Text
      pdf.setFontSize(13).setFont(undefined, "italic");
      let initText = pdf.splitTextToSize(
        props.Info.Reports.InitialText[pageName],
        180
      );
      pdf.text(pdf.internal.pageSize.getWidth() / 2, 30 + spacing, initText, {
        align: "center",
      });
      let initTextOffset = 5 * initText.length + 30 + spacing * 2;
      //Image
      let iheight = 80;
      let iwidth = 80;
      let ipadding = 60;
      await addSectionToPDF(
        `${pageName}_Image`,
        0,
        initTextOffset,
        pdf,
        ipadding,
        iheight,
        iwidth
      );
      //Bars
      let height = 115;
      let width = 115;
      if (pageName === "Efficiency") {
        height = 45;
        width = 100;
      }
      if (pageName === "Total") {
        height = 90;
      }
      await addSectionToPDF(
        `${pageName}_Bars`,
        0,
        initTextOffset + spacing + iheight,
        pdf,
        50,
        width,
        height
      );
      //Action Steps
      // console.log("filteredSCArr :>> ", filteredSCArr);
      // console.log("filteredSCArr.length :>> ", filteredSCArr.length);
      if (filteredSCArr.length > 0) {
        pdf.addPage();
        pdf.setFontSize(20).setFont(undefined, "normal");
        pdf.text(10, 20, `${pageName} Action Steps:`);

        let yOffset = 20;
        let newOffset;
        for (let i = 0; i < filteredSCArr.length; i++) {
          newOffset = prActionStep(filteredSCArr, i, 10 + yOffset, true);
          if (
            yOffset + newOffset + spacing >= 290 &&
            i < filteredSCArr.length
          ) {
            pdf.addPage();
            yOffset = 10;
            newOffset = prActionStep(filteredSCArr, i, 10 + yOffset);
            yOffset += newOffset + spacing;
            continue;
          }
          prActionStep(filteredSCArr, i, 10 + yOffset);
          yOffset += newOffset + spacing;
        }
      }
    }

    //#region Total Page
    // console.log("Info: ", JSON.stringify(props.Info));
    // console.log("Reports:", props.Info.Reports);
    // console.log("SC:", props.Info.Reports.SmartContracts);

    await sectionPage("Total", "QFP Score", props.Info.Reports.SmartContracts);

    //#endregion TotalPage

    //#region Defense Page

    await sectionPage(
      "Defense",
      "Defense Score",
      props.Info.Reports.SmartContracts
    );
    // await scorePage("Defense");
    // pdf.addPage();
    // await addSectionToPDF("Defense", 0, 0, pdf);
    //#endregion Defense Page
    //#region Defense Post
    pdf.addPage();
    pdf.addImage(
      Defense_Post,
      "PNG",
      0,
      0,
      pdf.internal.pageSize.getWidth(),
      pdf.internal.pageSize.getHeight()
    );

    pdf.addPage();
    pdf.addImage(
      Defense_Post_2,
      "PNG",
      0,
      0,
      pdf.internal.pageSize.getWidth(),
      pdf.internal.pageSize.getHeight()
    );
    //#endregion Defense Post

    //#region Offense Page
    await sectionPage(
      "Offense",
      "Offense Score",
      props.Info.Reports.SmartContracts
    );
    // await scorePage("Offense");
    // pdf.addPage();
    // await addSectionToPDF("Offense", 0, 0, pdf);
    //#endregion Offense Page
    //#region Offense Post
    pdf.addPage();
    pdf.addImage(
      Offense_Post,
      "PNG",
      0,
      0,
      pdf.internal.pageSize.getWidth(),
      pdf.internal.pageSize.getHeight()
    );
    //#endregion Offense Post

    //#region Efficiency PageOffense
    await sectionPage(
      "Efficiency",
      "Efficiency Score",
      props.Info.Reports.SmartContracts
    );
    // await scorePage("Efficiency");
    // pdf.addPage();
    // await addSectionToPDF("Efficiency", 0, 0, pdf);
    //#endregion Efficiency Page

    //#region Efficiency Post
    pdf.addPage();
    pdf.addImage(
      Efficiency_Post,
      "PNG",
      0,
      0,
      pdf.internal.pageSize.getWidth(),
      pdf.internal.pageSize.getHeight()
    );
    //#endregion Efficiency Post

    //#region Last Page
    pdf.addPage();
    pdf.addImage(
      LastPage,
      "PNG",
      0,
      0,
      pdf.internal.pageSize.getWidth(),
      pdf.internal.pageSize.getHeight()
    );
    //#endregion Last Page

    pdf.save(`QFP_Score-${dFileName}.pdf`);
    closeModal();
  };

  return (
    <div>
      <div
        className="NewProfileButton hoverBox"
        style={{ margin: "auto" }}
        onClick={clickHandler}
      >
        Get your full QFP Score here
      </div>

      <Popup open={open} onClose={closeModal}>
        <div className="header"> Generating PDF</div>
        <div className="modal_content">
          Please wait while we generate your Report
        </div>
        <div className="actions">
          {/* <div
            className="divButton modalButton"
            onClick={() => {
              closeModal();
            }}>
            Okay
          </div> */}
        </div>
      </Popup>
    </div>
  );
}

export default CreatePDF;
